import React from 'react';
import { useAdminUsersQuery, useRoleSelectListQuery } from 'api';
import { CalendarIcon } from 'components/common/icons';
import { Col, DatePicker, FilterDrawer, Form, FormInstance, Row, Select } from 'components';
import styles from '../styles.module.scss';
import { useFilters } from './useFilters';

const { RangePicker } = DatePicker;

interface IFilters {
  form: FormInstance;
  drawerOpen: boolean;
  closeDrawer: () => void;
  applyFilters: (value: Record<string, any>) => void;
  resetFilters: () => void;
}

export const Filters = React.memo((props: IFilters) => {
  const { form, drawerOpen, closeDrawer, applyFilters, resetFilters } = props;
  const { data: roleData = [] } = useRoleSelectListQuery();
  const { data: userData = [] } = useAdminUsersQuery();

  const { clearFilters } = useFilters({ form, resetFilters });

  return (
    <FilterDrawer
      title="Filter"
      placement="left"
      width={471}
      onClose={closeDrawer}
      open={drawerOpen}
      onApply={() => form.submit()}
      onClear={clearFilters}
      onExpand={closeDrawer}
    >
      <Form layout="vertical" form={form} onFinish={applyFilters}>
        <Row gutter={[0, 16]}>
          <Col span={24}>
            <Form.Item name="roleId" label={'Role'}>
              <Select options={roleData} />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item name="userIds" label={'Assigned Users'}>
              <Select mode={'multiple'} options={userData} />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item name="createdDate" label={'Created Date'}>
              <RangePicker
                suffixIcon={<CalendarIcon />}
                className={styles.range_picker}
                popupClassName={'fmg-range-picker'}
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item name="lastModifyDate" label={'Last Updated Date'}>
              <RangePicker
                suffixIcon={<CalendarIcon />}
                className={styles.range_picker}
                popupClassName={'fmg-range-picker'}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </FilterDrawer>
  );
});
